import Steps from 'antd/es/steps';
import type { ComponentProps } from 'react';
import { useMemo } from 'react';

import { useDraftStepProgress } from './hooks/useDraftStepProgress';
import { useDraftSteps } from './hooks/useDraftSteps';
import { formatStepTitle } from './utils/formatters';

import './Stepper.css';

type StepperProps = ComponentProps<typeof Steps> & {};

export const Stepper = ({ ...props }: StepperProps) => {
  const steps = useDraftSteps();

  const { findStepIndex, currentStep } = useDraftStepProgress();

  const currentStepIndex = useMemo(
    () => findStepIndex(currentStep),
    [findStepIndex, currentStep]
  );

  const items = useMemo(() => {
    return steps.map((step) => ({ title: formatStepTitle(step) }));
  }, [steps]);

  return (
    <Steps
      {...props}
      items={items}
      current={currentStepIndex}
      labelPlacement="vertical"
      className="stepper-icon-color-matching"
    />
  );
};
